import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { DialogCloseResult, DialogService } from "@progress/kendo-angular-dialog";
import { ActionService } from "app/intake/actions/action-service";
import { CorrespondanceDetailsComponent } from "app/intake/corresondance/correspondance-details/correspondance-details.component";
import { EMAIL_ACTIONS } from "app/_constants/emailActions";
import { FREQUENCIES } from "app/_constants/frequencies";
import { MESSAGE_OVERVIEW_TYPES } from "app/_constants/messageOverview";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-messages-overview-content",
    templateUrl: "./messages-overview-content.component.html",

})
export class MessagesOverviewContentComponent implements OnInit, OnDestroy {

    @Input() type: string;
    private _subject$: Subject<boolean> = new Subject();
    messages: any[] = [];
    isloading: boolean = false;
    selectedMessage: any;

    constructor(
        private actionService: ActionService,
        private cd: ChangeDetectorRef,
        private dialogService: DialogService,
    ) { }

    ngOnInit(): void {
        this.getMessages();
    }

    getClientName(dataitem) {
        return JSON.parse(dataitem.dossierAction.doaFreeText).doaOrganisation;
    }

    onCellClick($event) {
        this.selectedMessage = $event.dataItem
        this.selectedMessage.correspondanceAttachments = [];
        this.selectedMessage.post.postEmailCc = "";
    }

    openDetails() {
        if (this.selectedMessage != null)
            this.openDialog();
        this.selectedMessage = null;
    }

    openDialog() {
        const dialogRef = this.dialogService.open({
            content: CorrespondanceDetailsComponent,
            width: "80%"
        });
        dialogRef.content.instance.selectedCorrespondance = this.selectedMessage;
        dialogRef.content.instance.isOverviewMessage = true;
        dialogRef.content.instance.emailAction = EMAIL_ACTIONS.RESEND;
        dialogRef.result.subscribe((result: any) => {
            if (!(result instanceof DialogCloseResult)) {
            }
        });
    }

    getMessages() {
        this.isloading = true
        if (this.type == FREQUENCIES.DAILY) {
            this.actionService
                .getDailyMessages()
                .pipe(takeUntil(this._subject$))
                .subscribe((data: any) => {
                    this.messages = [...data];
                    this.isloading = false;
                    this.cd.detectChanges();
                });
        }
        else {
            this.actionService
                .getWeeklyMessages()
                .pipe(takeUntil(this._subject$))
                .subscribe((data: any) => {
                    this.messages = [...data];
                    this.isloading = false;
                    this.cd.detectChanges();
                });
        }
    }

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }
}